<button type="submit" class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular double-white"
    (click)="onClick();">
    <div>Download PO</div>
</button>
<app-error-dialog [modalId]="modalIdE" [title]="messageTitleE" [messageA]="messageMessageAE"
    [messageB]="messageMessageBE" [messageC]="messageMessageCE" [messageBClass]="messageMessageBClassE"
    [dialogClass]="dialogClassE"></app-error-dialog>